var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.740234,
    y: 0.389648,
    width: 65.7143,
    height: 65.7143,
    rx: 32.8571,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 37,
    height: 37
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 35.8442,
    height: 35.8442,
    transform: "matrix(-1 0 0 1 51.5195 15.3247)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5977 36.2336C34.8423 36.2336 35.9002 35.798 36.7714 34.9268C37.6426 34.0556 38.0782 32.9977 38.0782 31.7531V22.792C38.0782 21.5475 37.6426 20.4896 36.7714 19.6183C35.9002 18.7471 34.8423 18.3115 33.5977 18.3115C32.3531 18.3115 31.2952 18.7471 30.424 19.6183C29.5528 20.4896 29.1172 21.5475 29.1172 22.792V31.7531C29.1172 32.9977 29.5528 34.0556 30.424 34.9268C31.2952 35.798 32.3531 36.2336 33.5977 36.2336ZM35.0912 46.6881V42.0956C37.68 41.7471 39.8206 40.5897 41.5133 38.6232C43.2059 36.6568 44.0522 34.3667 44.0522 31.7531H41.0652C41.0652 33.8191 40.3371 35.5802 38.881 37.0364C37.4248 38.4925 35.6637 39.2206 33.5977 39.2206C31.5317 39.2206 29.7706 38.4925 28.3144 37.0364C26.8583 35.5802 26.1302 33.8191 26.1302 31.7531H23.1432C23.1432 34.3667 23.9895 36.6568 25.6821 38.6232C27.3748 40.5897 29.5154 41.7471 32.1042 42.0956V46.6881H35.0912ZM33.5977 33.2466C33.1745 33.2466 32.8198 33.1035 32.5336 32.8172C32.2473 32.531 32.1042 32.1762 32.1042 31.7531V22.792C32.1042 22.3689 32.2473 22.0142 32.5336 21.7279C32.8198 21.4417 33.1745 21.2985 33.5977 21.2985C34.0209 21.2985 34.3756 21.4417 34.6618 21.7279C34.9481 22.0142 35.0912 22.3689 35.0912 22.792V31.7531C35.0912 32.1762 34.9481 32.531 34.6618 32.8172C34.3756 33.1035 34.0209 33.2466 33.5977 33.2466Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.db4e18baa0e0e17bf1fff513cfc9dd4e.svg";
export { ForwardRef as ReactComponent };